import Component from './ParcelMapLink.js';
export default Component;
export { placeOrSay } from './ParcelMapLink.js';
